import { mulberry32 } from '../complexity';

/** 32 ビット FNV-1a（id から種を作る）。 */
export function fnv1a32(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h >>> 0;
}

/**
 * id を種にした決定的なシャッフル（card-schema.md §3.3, §3.4）。元の添字の列を返す。
 * avoidIdentity なら、2 個以上のとき元の並びそのものにはしない（parsons 用）。
 */
export function shuffledOrder(id: string, length: number, avoidIdentity = false): number[] {
  const order = Array.from({ length }, (_, i) => i);
  const rand = mulberry32(fnv1a32(id));
  for (let i = length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    const a = order[i] ?? i;
    order[i] = order[j] ?? j;
    order[j] = a;
  }
  if (avoidIdentity && length > 1 && order.every((v, i) => v === i)) {
    order.push(order.shift() ?? 0);
  }
  return order;
}

/** {@link shuffledOrder} で並べ替えた要素と元の添字。 */
export function shuffleById<T>(
  id: string,
  items: readonly T[],
  avoidIdentity = false,
): { item: T; index: number }[] {
  return shuffledOrder(id, items.length, avoidIdentity).flatMap((index) => {
    const item = items[index];
    return item === undefined ? [] : [{ item, index }];
  });
}
